import { IReleaseNote } from "../types"

export const RELEASE_1_4_2: IReleaseNote = {
    status: "PAST",
    title: "v1.4.2",
    date: "05 September 2024",
    releaseType: "Patch",
    notesBodyAllUsers: [
        {
            heading: "Introduction",
            content:
                "This is a patch release with some minor rewording to the; additional comments tool tip on the Generation Device form,the question relating to the single line diagram on the commisison form and some additional wording alignment for solo installers",
        },
    ],
    notesBodyInstaller: [
        {
            heading: "For installers using the web portal",
            content: "The following changes have been added:",
            bullets: [
                "Alignment of wording on the platform to state 'solo installer'",
                "Rewording of the single line diagram question, within the commissioning form",
            ],
        },
        {
            heading: "For installers using our APIs",
            content: "The following change has been added:",
            bullets: [
                "Rewording of the single line diagram question, within the commissioning form to correct and remove ambiguity introduced in 1.4.1. This has no impact on API integrations",
            ],
        },
    ],
    notesBodyDno: [
        {
            heading: "For DNOs using the web portal",
            content: "The following change has been added:",
            bullets: ["This release contains no changes to your functionality"],
        },
        {
            heading: "For DNOs using our APIs",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyManu: [
        {
            heading: "For manufacturers using the web portal",
            content:
                "Added commentary to the 'Additional Comments' tooltip on the Generation Device to make you aware of who is able to view the commentary",
        },
    ],
    notesBodyDbAssessorDemand: [
        {
            heading: "For demand evaluators using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyDbAssessorGen: [
        {
            heading: "For generation evaluators using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
}
